import React, { useContext, useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useHistory } from "react-router-dom";
import ActionTable from "../../../components/table/ActionTable";
import { formatDateTime, mergeParams } from "../../../helpers/helpers";
import Form from "../../../components/form";
import api from "../../../services/api";
import comunidade from '../../../services/comunidade';
import AppContext from "../../../container/context";

const listaSituacao = [
  { id: 1, nome: "Em andamento" },
  { id: 2, nome: "Aguardando pagamento" },
  { id: 3, nome: "Enviado" },
  { id: 4, nome: "Cancelado" },
  { id: 5, nome: "Expirado" },
];

export default function Lista({ location }) {
  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        codigo: "",
        situacao: 0,
        usuarioNome: "",
        usuarioEmail: "",
        usuarioCPF: "",
        exibirCancelados: false,
      },
      location
    )
  );
  const [registros, setRegistros] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const history = useHistory();
  const { notification } = useContext(AppContext);

  useEffect(() => {
    listar();
  }, []);

  const listar = (filtrosEnviar = filtros) => {
    setCarregando(true);
    setFiltros(filtrosEnviar);

    comunidade
      .get("admin/pedidos/listar", filtrosEnviar)
      .then((res) => {
        const registros = res;
        registros.forEach((r) => {
          r.data = formatDateTime(r.registro, "D/M/Y h:m");
          r.status =
            listaSituacao.find((situacao) => situacao.id === r.situacao)
              ?.nome || "Situação não encontrada";

          if (r.situacao === 2) {
            if (r.modalidadePagamento === 1) {
              r.status = "Aguadando pagamento (boleto bancário)";
            }
            if (r.modalidadePagamento === 2) {
              r.status = "Aguadando pagamento (cartão de crédito)";
            }
            if (r.modalidadePagamento === 3) {
              r.status = "Aguadando pagamento (pix)";
            }
          }
        });
        setRegistros(registros);
        setCarregando(false);
      })
      .catch((e) => {
        notification(
          "error",
          "Não foi possível listar os acompanhamentos. Verifique sua conexão e tente novamente."
        );
        setCarregando(false);
      });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      codigo: {
        label: "Código",
        type: "text",
        space: 3,
        value: filtros.codigo,
      },
      situacao: {
        label: "Situação",
        type: "select",
        emptyItem: true,
        emptyItemText: "(todas)",
        space: 3,
        array: {
          data: [
            { id: 1, nome: "Em andamento" },
            { id: 2, nome: "Aguardando pagamento" },
            { id: 3, nome: "Enviado" },
            { id: 4, nome: "Cancelado" },
            { id: 5, nome: "Expirado" },
          ],
          value: "id",
          desc: "nome",
        },
        value: filtros.situacao,
      },
      exibirCancelados: {
        label: "Exibir cancelados",
        type: "check",
        space: 6,
        value: filtros.exibirCancelados,
      },
      usuarioNome: {
        label: "Nome do responsável",
        type: "text",
        space: 6,
        value: filtros.usuarioNome,
      },
      usuarioEmail: {
        label: "Email do responsável",
        type: "text",
        space: 3,
        value: filtros.usuarioEmail,
      },
      usuarioCPF: {
        label: "CPF do responsável",
        type: "text",
        space: 3,
        value: filtros.usuarioCPF,
      },
    },

    submit: {
      label: "Buscar",
      action: listar,
    },

    urlParams: true,
    history,
    location,
  };

  const tPedidos = {
    title: "Pedidos",
    onLineClick: (id) => history.push(`/app/comunidade-pedidos/${id}`),
    key: "id",
    columns: [
      {
        label: "Código",
        name: "id",
      },
      {
        label: "Registro",
        name: "data",
      },
      {
        label: "Responsável",
        name: "usuarioNome",
      },
      {
        label: "Situação",
        name: "status",
      },
    ],
    array: registros,
  };

  return (
    <div>
      <Form formData={fFiltros} />

      {carregando ? <CircularProgress /> : <ActionTable structure={tPedidos} />}
    </div>
  );
}
